import { BaseEntryScope, createEntryPoint } from '#packages/apilib';
import {
  EditorAPIKey,
  EditorCoreApiKey,
  WorkspaceModesApiKey,
} from '#packages/apis';
import { WorkspaceModesApi } from './workspaceModesApi';

export class WorkspaceModesScope extends BaseEntryScope {
  editorAPI = this.useDependency(EditorAPIKey);
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
}

export const WorkspaceModesEntryPoint = createEntryPoint({
  name: 'WorkspaceModes',
  Scope: WorkspaceModesScope,
  publicApi({ contributeApi }) {
    contributeApi(WorkspaceModesApiKey, WorkspaceModesApi);
  },
  async initialize({ editorCoreAPI }: WorkspaceModesScope) {
    await editorCoreAPI.hooks.initReady.promise;
    editorCoreAPI.hooks.workspaceModesInit.resolve();
  },
});
